export interface DemoCredential {
  userId: string;
  email: string;
  displayName: string;
}

export interface DemoCredentialWithPassword extends DemoCredential {
  password: string;
}

export const DEMO_CREDENTIALS: DemoCredentialWithPassword[] = [
  {
    userId: '201',
    email: 'katherine@go2impact.com',
    displayName: 'Katherine',
    password: 'ops-demo'
  },
  {
    userId: '353',
    email: 'cha@go2.io',
    displayName: 'Cha',
    password: 'data-demo'
  },
  {
    userId: '372',
    email: 'marc.a@go2.io',
    displayName: 'Marc',
    password: 'success-demo'
  },
  {
    userId: '3',
    email: 'rustan@go2.io',
    displayName: 'Rustan Corpuz',
    password: 'Notasecret1!'
  },
  {
    userId: '583',
    email: 's@go2.io',
    displayName: 'Scott Moran',
    password: 'Notasecret1!'
  }
];

export const sanitizeCredential = (credential: DemoCredentialWithPassword): DemoCredential => {
  const { password, ...rest } = credential;
  return rest;
};
